// Care plan enum option lists. Values are sent VERBATIM to the backend — do not
// rename. Labels follow the HSE "Personalised Care Plan" GP Screen wording.

export const MANAGEMENT_TOPICS = [
  { topic: "DIET", label: "Eat an appropriate diet" },
  { topic: "WEIGHT", label: "Monitor my weight" },
  { topic: "BREATHLESSNESS", label: "Monitor breathlessness" },
  { topic: "APPOINTMENTS", label: "Attending appointments" },
  { topic: "OTHER", label: "Other comments" },
];

export const SELF_MANAGEMENT_PLAN_OPTIONS = [
  { value: "COPD", label: "COPD" },
  { value: "HEART_FAILURE", label: "Heart Failure" },
  { value: "ASTHMA", label: "Asthma" },
];

// Full referral list — CDM uses all of these.
export const CDM_REFERRAL_OPTIONS = [
  { value: "PHN", label: "PHN" },
  { value: "PODIATRIST", label: "Podiatrist" },
  { value: "DIETICIAN", label: "Dietician" },
  { value: "PULMONARY_REHAB", label: "Pulmonary Rehab" },
  { value: "CARDIAC_REHAB", label: "Cardiac Rehab" },
  { value: "SPECIALIST_CARE", label: "Specialist Care" },
  { value: "SOCIAL_PRESCRIBING", label: "Social prescribing" },
  { value: "SMOKING_CESSATION", label: "Smoking cessation" },
  { value: "COUNSELLING_PSYCHOLOGY", label: "Counselling / Psychology" },
  { value: "PHYSIOTHERAPY", label: "Physiotherapy" },
  { value: "OCCUPATIONAL_THERAPY", label: "Occupational therapy" },
  { value: "SOCIAL_WORK", label: "Social Work" },
  { value: "STRUCTURED_PATIENT_EDUCATION", label: "Structured Patient Education" },
  { value: "RETINA_SCREEN", label: "RetinaScreen" },
];

// PP drops Pulmonary Rehab, Cardiac Rehab, Structured Patient Education and
// RetinaScreen, and adds the Diabetes Prevention Programme.
export const PP_REFERRAL_OPTIONS = [
  { value: "PHN", label: "PHN" },
  { value: "PODIATRIST", label: "Podiatrist" },
  { value: "DIETICIAN", label: "Dietician" },
  { value: "SPECIALIST_CARE", label: "Specialist Care" },
  { value: "SOCIAL_PRESCRIBING", label: "Social prescribing" },
  { value: "SMOKING_CESSATION", label: "Smoking cessation" },
  { value: "COUNSELLING_PSYCHOLOGY", label: "Counselling / Psychology" },
  { value: "PHYSIOTHERAPY", label: "Physiotherapy" },
  { value: "OCCUPATIONAL_THERAPY", label: "Occupational therapy" },
  { value: "SOCIAL_WORK", label: "Social Work" },
  { value: "DIABETES_PREVENTION_PROGRAMME", label: "Diabetes Prevention Programme" },
];

export const getReferralOptions = (isPp) =>
  isPp ? PP_REFERRAL_OPTIONS : CDM_REFERRAL_OPTIONS;

export const MAX_TAKE_HOME_MESSAGES = 3;
